import { useGetActionPlansByReport } from '@/hooks/useGetActionPlansByReport';
import { useDataExtractionReport } from '@/context/DataExtractionReport';

export const useHandleActionPlanExtraction = (reportType: string, dataExtractionId?: string) => {
	const { dataExtractionReport } = useDataExtractionReport();

	const isEditMode = Boolean(dataExtractionReport?.id);

	const {
		data: actionPlans,
		refetch,
		isFetching
	} = useGetActionPlansByReport({
		organization_id: dataExtractionReport?.organization_id!,
		company_id: dataExtractionReport?.company_id!,
		report_type: reportType,
		sector_id: dataExtractionReport?.sector_id!,
		line_id: dataExtractionReport?.line_id!,
		workstation_id: dataExtractionReport?.workstation_id!,
		start_date: dataExtractionReport?.start_date!,
		end_date: dataExtractionReport?.end_date!,
		data_extraction_id: dataExtractionId
	});

	const currentActionPlan = { total_action_plans: actionPlans?.count || 0 };
	const hasActionPlans = Number(currentActionPlan.total_action_plans) > 0;

	return {
		hasActionPlans,
		currentActionPlan,
		isEditMode,
		refetch,
		isLoading: isFetching
	};
};
